"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergeStylesHooks = void 0;
var React = require("react");
var MergeStylesDefaultContext_1 = require("../contexts/MergeStylesDefaultContext");
var useMergeStylesHooks = function () {
    var ctx = React.useContext(MergeStylesDefaultContext_1.MergeStylesDefaultContext);
    return {
        useAdoptedStylesheet: ctx.useAdoptedStylesheet,
        useAdoptedStylesheetEx: ctx.useAdoptedStylesheetEx,
        useShadowConfig: ctx.useShadowConfig,
        useMergeStylesShadowRootContext: ctx.useMergeStylesShadowRootContext,
        useHasMergeStylesShadowRootContext: ctx.useHasMergeStylesShadowRootContext,
        useMergeStylesRootStylesheets: ctx.useMergeStylesRootStylesheets,
        useWindow: ctx.useWindow,
        useStyled: ctx.useStyled,
    };
};
exports.useMergeStylesHooks = useMergeStylesHooks;
//# sourceMappingURL=useMergeStylesHooks.js.map